<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <el-text-field
          label="Unikalus atpažinties kodas"
          tooltip="Hipoteka. Turtas. Traktorius. Unikalus atpažinties kodas"
          :readonly="turtasReadonly || !sudarymas"
          :counter="10"
          v-model="formData.tur_identifikatorius"
          :autofocus="!turtasReadonly && sudarymas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Registracijos liudijimo numeris"
          tooltip="Hipoteka. Turtas. Traktorius. Registracijos liudijimo numeris"
          :readonly="turtasReadonly"
          :counter="20"
          v-model="formData.tur_traktorius_registracijos_numeris"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Registracijos vieta"
          tooltip="Hipoteka. Turtas. Traktorius. Registracijos vieta"
          :readonly="turtasReadonly"
          :counter="200"
          v-model="formData.tur_traktorius_registracijos_vieta"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Valstybinis numeris"
          tooltip="Hipoteka. Turtas. Traktorius. Valstybinis numeris"
          :readonly="turtasReadonly"
          :counter="50"
          v-model="formData.tur_traktorius_valstybinis_numeris"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Tapatumo numeris"
          tooltip="Hipoteka. Turtas. Traktorius. Tapatumo numeris"
          :readonly="turtasReadonly"
          :counter="50"
          v-model="formData.tur_traktorius_tapatumo_numeris"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-date-picker
          label="Gamybos metai"
          tooltip="Hipoteka. Turtas. Traktorius. Gamybos metai"
          :readonly="turtasReadonly"
          v-model="formData.tur_traktorius_gamybos_metai"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Markė, modelis"
          tooltip="Hipoteka. Turtas. Traktorius. Markė, modelis"
          :readonly="turtasReadonly"
          :counter="150"
          v-model="formData.tur_traktorius_modelis"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Pavadinimas"
          tooltip="Hipoteka. Turtas. Traktorius. Pavadinimas"
          :readonly="turtasReadonly"
          :counter="100"
          v-model="formData.tur_traktorius_pavadinimas"
        />
      </v-col>
      <v-col cols="12" md="6" v-if="showIsregistruotas">
        <el-checkbox
          class="mb-3 mt-0"
          label="Išregistruotas"
          tooltip="Hipoteka. Turtas. Traktorius. Išregistruotas"
          :readonly="turtasReadonly"
          v-model="formData.tur_traktorius_isregistruotas"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasTraktorius',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !this.irasomas
    },
    showIsregistruotas() {
      return this.formData.tur_traktorius_isregistruotas
    },
  },
}
</script>
